import { mapState } from 'vuex';

export default {
    name: 'course_progress',
    props: {
        course : Object,
        focused : String,
        notdisplayprogress : Boolean
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        progress : function(state){
            return state._progress[this.course.uid] || (new this.core.api.kt.LessonProgress())
        },
        lessonStatuses : function(){

            if(this.notdisplayprogress) return {}

            var ls = this.progress.lessonStatuses(this.course)
            
            return ls
        }
    }),

    methods : {
        click : function(index){
            this.$emit('click', index)
        }
    },
}